export default __webpack_public_path__ + "691a1137ac535027d9186239439f09c7.png";